import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "categoriesSelect",
    "getAudiencesEndpoint",
    "audiencesContainer",
    "audiencesList",
    "audienceTemplate",
  ];

  initialize() {
    this.categoriesSelectTarget.setAttribute(
      "data-action",
      "change->programs#changeAudiances"
    );
  }

  changeAudiances() {
    var categoryId = event.target.value;
    var audiencesEndpoint =
      this.getAudiencesEndpointTarget.value + "?category_id=" + categoryId;

    fetch(audiencesEndpoint)
      .then((response) => response.json())
      .then((data) => {
        if (data.code == 200) {
          var newSelectElements = this.audiencesListTarget.querySelectorAll(
            "select.new-select-true"
          );

          var templateSelectElements =
            this.audienceTemplateTarget.querySelectorAll(
              "select.new-select-true"
            );

          newSelectElements.forEach((selectElement) => {
            const options = data.options.map(([label, value]) => {
              const option = document.createElement("option");
              option.value = value;
              option.textContent = label;
              return option;
            });

            selectElement.replaceChildren(...options);
          });

          templateSelectElements.forEach((selectElement) => {
            const options = data.options.map(([label, value]) => {
              const option = document.createElement("option");
              option.value = value;
              option.textContent = label;
              return option;
            });

            selectElement.replaceChildren(...options);
          });

          this.audiencesContainerTarget.replaceChildren();
        }
      });
  }
}
